import SectionTitle from '../../components/Common/SectionTitle';

// WhyChooseUs Images
import mainImg from '../../assets/img/choose/2.png';
import animImg1 from '../../assets/img/choose/dotted-1.png';
import animImg2 from '../../assets/img/choose/dotted-2.png';
import iconOne from '../../assets/img/choose/icons/1.png';
import iconTwo from '../../assets/img/choose/icons/2.png';
import iconThree from '../../assets/img/choose/icons/3.png';


const WhyChooseUs = () => {

    return (
        <div className="rs-why-choose style1 black-dark pt-120 pb-120 md-pt-70 md-pb-74">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 hidden-md">
                        <div className="image-part">
                            <img
                                src={mainImg}
                                alt="Main Image"
                            />
                        </div>
                        <div className="animation style2 modify-style">
                            <div className="top-shape">
                                <img
                                    className="dance"
                                    src={animImg2}
                                    alt="Animation Two"
                                />
                            </div>
                            <div className="bottom-shape">
                                <img
                                    className="dance2"
                                    src={animImg1}
                                    alt="Animation One"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 pl-60 md-pl-14">
                        <SectionTitle
                            sectionClass="sec-title mb-40"
                            subtitleClass="sub-text white-color style4-bg"
                            subtitle="Por que escolher a Ayit?"
                            titleClass="title white-color pb-20"
                            title="Buscamos resultados através de aplicações dinâmicas"
                            descClass="desc white-color"
                            description="Usamos cultura e metodologias de trabalho ágeis para entregar o melhor resultado em TI, para que o cliente tenha mais ferramentas para focar no seu mercado."
                        />
                        <div className="services-wrap mb-24">
                            <div className="services-icon">
                                <img
                                    src={iconOne}
                                    alt="Choose Icon"
                                />
                            </div>
                            <div className="services-text">
                                <h3 className="title white-color"><a href="#">Sprints de Entregas Ágeis</a></h3>
                                <p className="services-txt white-color">  Controle prévio do cliente nos prazos de entregas de novas funcionalidades e no MVP.</p>
                            </div>
                        </div>
                        <div className="services-wrap mb-24">
                            <div className="services-icon">
                                <img
                                    src={iconTwo}
                                    alt="Choose Icon"
                                />
                            </div>
                            <div className="services-text">
                                <h3 className="title white-color"><a href="#">Código Proprietário</a></h3>
                                <p className="services-txt white-color">  Em projetos customizados, o cliente pode optar em ter o código-fonte de todo seu projeto, ao final do MVP.</p>                                
                            </div>
                        </div>
                        <div className="services-wrap">
                            <div className="services-icon">
                                <img
                                    src={iconThree}
                                    alt="Choose Icon"
                                />
                            </div>
                            <div className="services-text">
                                <h3 className="title white-color"><a href="#">Documentação</a></h3>
                                <p className="services-txt white-color">  A documentação técnica de toda solução é entregue ao final de cada projeto.<br></br> 
                                O cliente pode internalizar seu sistema ou continuar com a Ayit cuidando dele, se assim desejar.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyChooseUs;